define('TescoMobile_Checkout/js/model/choice-resource-url-manager',['Magento_Customer/js/model/customer', 'TescoMobile_DynamicBundleOptions/js/dynamic-options/model/url-builder', 'mageUtils'], function (customer, urlBuilder, utils) {
  'use strict';

  return {
    getUrlForGetSpendCaps: function (quote, quoteItemId) {
      var params = {
        quoteItemId: quoteItemId,
        cartId: quote.getQuoteId()
      };
      var urls = {
        'guest': '/guest-carts/:cartId/spend-cap/:quoteItemId',
        'customer': '/carts/mine/spend-cap/:quoteItemId'
      };
      return this.getUrl(urls, params);
    },
    getUrlForSaveSpendCap: function (quote, quoteItemId, sku) {
      var params = {
        quoteItemId: quoteItemId,
        cartId: quote.getQuoteId(),
        sku: sku
      };
      var urls = {
        'guest': '/guest-carts/:cartId/spend-cap/:quoteItemId/:sku',
        'customer': '/carts/mine/spend-cap/:quoteItemId/:sku'
      };
      return this.getUrl(urls, params);
    },
    getUrlForGetInsurances: function (quoteMask, quoteItemId) {
      var params = {
        quoteItemId: quoteItemId,
        quoteMask: quoteMask
      };
      var urls = {
        'guest': '/guest-carts/:quoteMask/insurance/:quoteItemId',
        'customer': '/carts/mine/insurance/:quoteItemId'
      };
      return this.getUrl(urls, params);
    },
    getUrlForSaveInsurance: function (quoteMask, quoteItemId, sku) {
      var params = {
        quoteItemId: quoteItemId,
        quoteMask: quoteMask,
        sku: sku
      };
      var urls = {
        'guest': '/guest-carts/:quoteMask/insurance/:quoteItemId/:sku',
        'customer': '/carts/mine/insurance/:quoteItemId/:sku'
      };
      return this.getUrl(urls, params);
    },
    getUrlForGetFamilyPerks: function (quote) {
      var params = {
        cartId: quote.getQuoteId()
      };
      var urls = {
        'guest': '/guest-carts/:cartId/family-perk-cart',
        'customer': '/carts/mine/family-perk-cart'
      };
      return this.getUrl(urls, params);
    },
    getUrlForSaveFamilyPerk: function (quote, quoteItemId, sku) {
      var params = {
        quoteItemId: quoteItemId,
        cartId: quote.getQuoteId(),
        sku: sku
      };
      var urls = {
        'guest': '/guest-carts/:cartId/family-perk/:quoteItemId/:sku',
        'customer': '/carts/mine/family-perk/:quoteItemId/:sku'
      };
      return this.getUrl(urls, params);
    },
    getUrlForValidateCartItems: function (quote, quoteItemId) {
      var params = {
        cartId: quote.getQuoteId()
      };
      var urls = {
        'guest': '/guest-carts/:cartId/validate-selected-options',
        'customer': '/carts/mine/validate-selected-options'
      };
      return this.getUrl(urls, params);
    },
    getUrlForValidateKbaQuestions: function (quote, quoteItemId) {
      var params = {
        cartId: quote.getQuoteId()
      };
      var urls = {
        'guest': '/guest-carts/:cartId/submit-kba',
        'customer': '/carts/mine/submit-kba'
      };
      return this.getUrl(urls, params);
    },
    getUrlForCheckInsurancePerk: function (quote, quoteItemId) {
      var params = {
        cartId: quote.getQuoteId(),
        quoteItemId: quoteItemId
      };
      var urls = {
        'guest': '/guest-carts/:cartId/check-insurance-perk/:quoteItemId',
        'customer': '/carts/mine/check-insurance-perk/:quoteItemId'
      };
      return this.getUrl(urls, params);
    },
    getUrlForGetPortingItems: function (quoteId) {
      var params = {
        cartId: quoteId
      };
      var urls = {
        'guest': '/guest-carts/:cartId/get-porting-items',
        'customer': '/carts/mine/get-porting-items'
      };
      return this.getUrl(urls, params);
    },
    getUrlForGetKbaQuestions: function (quoteId) {
      var params = {
        cartId: quoteId
      };
      var urls = {
        'guest': '/guest-carts/:cartId/get-kba-questions',
        'customer': '/carts/mine/get-kba-questions'
      };
      return this.getUrl(urls, params);
    },
    getUrl: function (urls, urlParams) {
      var url;
      if (utils.isEmpty(urls) || !urls[this.getCartType()]) {
        return 'Provided service call does not exist.';
      }
      url = urls[this.getCartType()];
      return urlBuilder.createUrl(url, urlParams);
    },
    getCartType: function () {
      return customer.isLoggedIn() ? 'customer' : 'guest';
    }
  };
});

